import {
  Filter,
  FilterListRounded,
  RefreshOutlined,
} from "@mui/icons-material";
import { Badge, Box, IconButton, Tooltip } from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import React from "react";
import { BaseDrawer } from "src/components/dialogs/BaseDrawer";
import TableFilter from "src/components/tableFilter/TableFilter";
import { TableFilterProps } from "src/models/filter";
import { useAppZStore } from "src/store/zStore";

interface Props {
  refetch: () => void;
  isFetching: boolean;
  filterConfig?: TableFilterProps;
  filterMode: "default" | "custom" | "none";
}

export function TableToolbar({
  refetch,
  isFetching,
  filterConfig,
  filterMode,
}: Props) {
  const openDrawer = useAppZStore((state) => state.openDrawer);
  const filtersLength = useAppZStore((state) =>
    state.filters[filterConfig?.tableName ?? ""]
      ? Object.keys(state.filters[filterConfig?.tableName ?? ""]).length
      : null
  );

  const openFilter = () => {
    openDrawer({
      drawerContent: (
        <TableFilter
          tableName={filterConfig?.tableName ?? ""}
          config={filterConfig?.config ?? []}
          schema={filterConfig?.schema ?? undefined}
        />
      ),
      drawerDirection: "right",
    });
  };

  const filter: Record<typeof filterMode, React.ReactNode> = {
    none: <Box height={"30px"} />,
    default: <GridToolbarFilterButton />,
    custom: (
      <IconButton onClick={() => openFilter()}>
        <Badge badgeContent={filtersLength} color="primary">
          <FilterListRounded color="primary" />
        </Badge>
      </IconButton>
    ),
  };

  return (
    <GridToolbarContainer sx={{ justifyContent: "left" }}>
      {filter[filterMode]}

      <Box position="absolute" sx={{ right: "2px" }}>
        {refetch && (
          <Tooltip title="Refresh">
            <IconButton onClick={() => refetch()}>
              <RefreshOutlined
                sx={
                  isFetching
                    ? {
                        color: "yellow",
                        animation: "spin 2s linear infinite",
                        "@keyframes spin": {
                          "100%": {
                            transform: "rotate(360deg)",
                          },
                          "0%": {
                            transform: "rotate(0deg)",
                          },
                        },
                      }
                    : { color: "green" }
                }
              />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <BaseDrawer />
    </GridToolbarContainer>
  );
}

export default TableToolbar;
